import script from "./Toast.vue?vue&type=script&lang=ts&setup=true"
export * from "./Toast.vue?vue&type=script&lang=ts&setup=true"

import "./Toast.vue?vue&type=style&index=0&id=5bd32d66&scoped=true&lang=less"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd32d66"]])

export default __exports__